import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { ClientService } from "src/app/services/clients/client.service";
import {
  CommonMessages,
  ClientMessages,
} from "src/app/shared/messages/messages.enum";
import { BaseComponent } from "../../base.component";
import { AppConstants } from "src/app/_helpers/app.constants";
import { Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { EmailBuilderService } from "src/app/services/emailbuilder/emailbuilder.service";
import { CbService } from "src/app/services/contentbuilder/contentbuilder.service";
import { MatSelectChange } from "@angular/material/select";
import { AbstractControl } from "@angular/forms";
import { MasterService } from "src/app/services/master/master.service";
import { Subject, Subscription } from "rxjs";
import { CampaignBuilderService } from "src/app/services/segmentation/campaign-builder.service";
import {
  CbEmailTableStateService,
  UsersFilters,
} from "./cb-email-table.service";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pairwise,
  skip,
  startWith,
  take,
} from "rxjs/operators";
import { TableState } from "src/app/services/base-table-state.service";

@Component({
  selector: "app-cb-email-builder",
  // standalone: true,
  // imports: [],
  templateUrl: "./cb-email-templates.component.html",
  styleUrls: ["./cb-email-templates.component.scss"],
})
export class CBEmailTemplatesComponent extends BaseComponent implements OnInit {
  viewType: "list" | "card" = "card";
  selectedImage: string | null = null;
  selectedTemplateName: string = "";
  moveModalData = [];
  moveModalTitle: string = "Move Template";
  searchTemplateText: string = "";
  journeyThemeObj = [];
  // selectedThemeIds: number;
  currentJourneyData: {
    theme_ids: [];
    templateID: number;
    companyID: number;
  };
  // currentTemplateId: number;
  // treeData = [];
  isMoveModalOpen = false;

  currentUser: any;
  companyID: number | null = null;
  journeyID: number | null = null;
  themesID: number[] = [];
  domainID: number | null = null;
  prevDomainID: number | null = null;

  isAllowed: boolean;
  public companyObj: any = [];
  templateFilterData: any = [];
  AppConstants: AppConstants;
  totalCount: number = 0;
  page = 1;
  limit = 12;
  skip = 0;
  jorneyType: any = [];
  themeList: any = [];
  getCompanyobj: any = [];
  domainData: any = [];
  expandBtnText: string = "More Text";
  private sub = new Subscription();
  searchSubject: Subject<string> = new Subject();

  isCloneModalOpen: boolean = false;
  cloneModalTitle: string = 'Clone Template';
  currentCloneData: any = null;

  constructor(
    private campaignBuilderService: CampaignBuilderService,
    private eb: EmailBuilderService,
    private spinner: NgxSpinnerService,
    private clientService: ClientService,
    public location: Location,
    private cdr: ChangeDetectorRef,
    private cb: CbService,
    public master: MasterService,
    public tableState: CbEmailTableStateService,
  ) {
    super();
  }

  openPreview(event: any, image: any) {
    this.selectedImage = null;
    this.cdr.detectChanges();
    this.selectedImage = image;
    this.selectedTemplateName = event.tempName;
  }
  closePreview() {
    this.selectedImage = null;
  }

  setView(type: "list" | "card") {
    this.viewType = type;
  }

  clearFilter() {
    this.tableState.reset();
    this.companyID = null;
    this.journeyID = null;
    this.themesID = [];
    this.domainID = null;
    this.jorneyType = [];
    this.domainData = [];
    this.themeList = [];
    this.companyObj = [];
    this.templateFilterData = [];
    this.searchTemplateText = "";
    this.page = 1;
    this.limit = 12;
    this.skip = 0;
    this.totalCount = 0;
  }

  searchTemplate() {
    this.searchSubject.next(this.searchTemplateText);
  }

  moveTemplate(moveData: any) {
    this.fetchJourneyThemes(moveData?.company_id);
    this.currentJourneyData = {
      theme_ids: moveData.theme_ids.split(",").map(Number),
      templateID: Number(moveData.id),
      companyID: Number(moveData.company_id),
    };

    // this.selectedThemeIds = Number(moveData.theme_ids);
    // this.currentTemplateId = Number(moveData.id);
  }

  closeMoveModal() {
    // this.moveModalData = null;
    this.isMoveModalOpen = false;
  }

  ngOnInit() {
    this.getCompany();
    this.currentUser = JSON.parse(sessionStorage.getItem("userData"));
    // Handle state changes with pairwise to get previous and current state
    this.sub.add(
      this.tableState.state$
        .pipe(pairwise())
        .subscribe(([prev, curr]) => this.handleStateChanges(prev, curr)),
    );
    // Handle FIRST load separately
    this.sub.add(
      this.tableState.state$
        .pipe(take(1))
        .subscribe((state) => this.handleInitialLoad(state)),
    );
    // Search changes (debounced)
    this.sub.add(
      this.tableState.state$
        .pipe(skip(1), debounceTime(700), distinctUntilChanged())
        .subscribe((state) => {
          const companyID = this.tableState.snapshot.filters.companyID;
          if (companyID === null) return;

          this.searchTemplateText = state.searchTerm;
          if (this.searchTemplateText.trim() === "") {
            this.getEmailTemplateData(this.companyID, "search cleared");
          }
        }),
    );

    this.searchSubject.pipe(debounceTime(500)).subscribe((value: any) => {
      this.tableState.updateSearch(value);
    });

  }

  showToggle(evenet: any, subjectRef: HTMLElement) {
    const expandBtn = evenet.target as HTMLElement;
    const subjectElement = subjectRef;
    if (!subjectElement) return;
    const isExpanded = subjectElement.classList.contains("expanded");
    subjectElement.classList.toggle("expanded", !isExpanded);
    expandBtn.innerHTML = !isExpanded ? "More Text" : "Less Text";
  }

  private handleInitialLoad(state: TableState<UsersFilters>) {
    if (this.isDefaultFilters(state.filters)) {
      return;
    }

    const filters = state.filters;

    // immediately honour the saved domain value – it will be
    // re‑applied again after the list of domains has been fetched.
    this.domainID = filters.domainID !== null ? Number(filters.domainID) : null;
    this.prevDomainID = this.domainID;

    this.companyID = filters.companyID;
    this.journeyID = filters.journeyID;
    this.themesID = this.journeyID ? filters.themesID : [];
    this.page = state.pageIndex;
    this.limit = state.pageSize;

    // if somehow we have a domain but no company, drop it – we can't
    // fetch domains without knowing the company and the value would
    // never match any option.
    if (!this.companyID && this.domainID !== null) {
      this.domainID = null;
      this.prevDomainID = null;
      this.tableState.updateFilters({ domainID: null });
    }

    if (this.companyID) {
      this.getCompanyJourneyType();
      this.getBusinessDomain();
    }
    if (this.journeyID) this.getThemeList();
    if (state.searchTerm != "") this.searchTemplateText = state.searchTerm;

    if (state.pageIndex !== 1 || state.pageSize !== 10) {
      this.page = state.pageIndex;
      this.limit = state.pageSize;
    }

    this.getEmailTemplateData(this.companyID, "initial load");
  }

  private handleStateChanges(
    prevState: TableState<UsersFilters>,
    currState: TableState<UsersFilters>,
  ) {
    const prevFilters = prevState.filters;
    const currFilters = currState.filters;

    if (this.isDefaultFilters(currState.filters)) {
      return;
    }
    // Company Changed
    if (prevFilters.companyID !== currFilters.companyID) {
      this.companyID = currFilters.companyID;
      // company change invalidates any domain selection
      this.domainID = null;
      this.prevDomainID = null;
      this.getCompanyJourneyType();
      this.getBusinessDomain();
    }
    // Journey Changed
    if (prevFilters.journeyID !== currFilters.journeyID) {
      this.journeyID = currFilters.journeyID;
      this.getThemeList();
    }
    // Theme Changed
    const themesChanged =
      prevFilters.themesID.length !== currFilters.themesID.length ||
      prevFilters.themesID.some((id, i) => id !== currFilters.themesID[i]);
    if (themesChanged) {
      this.themesID = currFilters.themesID;
    }
    // Domain Changed
    if (prevFilters.domainID !== currFilters.domainID) {
      this.domainID =
        currFilters.domainID !== null ? Number(currFilters.domainID) : null;
    }
    // Pagination Changed
    if (
      prevState.pageIndex !== currState.pageIndex ||
      prevState.pageSize !== currState.pageSize
    ) {
      this.page = currState.pageIndex;
      this.limit = currState.pageSize;
    }
    this.getEmailTemplateData(this.companyID, "state change");
  }

  private isDefaultFilters(filters: UsersFilters): boolean {
    return (
      filters.companyID === null &&
      filters.journeyID === null &&
      filters.themesID.length === 0 &&
      filters.domainID === null
    );
  }

  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(
      (data) => {
        self.getCompanyobj = data.data;
        self.hydrateWorkingCompany(self, (id) => { self.onCompanyChange({ value: Number(id) } as any); });

        this.getCompanyobj = this.getCompanyobj.sort((a, b) => {
          return a.customer_company_name.localeCompare(b.customer_company_name);
        });
      },
      (error) => {},
    );
  }

  async fetchJourneyThemes(companyId: number) {
    if (companyId) {
      let self = this;
      this.spinner.show();
      this.clientService.getFetchJourneyThemes(companyId).subscribe(
        (data) => {
          if (data.status) {
            if (data?.data?.rows[0].result !== null) {
              this.moveModalData = data?.data?.rows[0].result.map(
                (journey: any, index: number) => ({
                  id: index + 1,
                  name: journey.journey_name,
                  open: false,
                  children: journey.theme_details.map((theme: any) => ({
                    id: theme.theme_id,
                    name: theme.theme_name,
                  })),
                }),
              );
              this.isMoveModalOpen = true;
            } else {
              // this.toastrService.error(
              //   "No journeys available to move this email template.",
              // );
              this.isMoveModalOpen = true;
              this.moveModalData = [];
            }
            this.spinner.hide();
          } else {
            self.moveModalData = [];
            // self.journeyThemeObj = [];
            this.spinner.hide();
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        },
      );
    } else {
      this.journeyThemeObj = [];
      this.spinner.hide();
    }
    // console.log("Selected Company ID:", this.journeyTypeObj);
  }

  getCompanyJourneyType() {
    this.ngxSpinnerService.show();
    this.clientService.getAllJourney(this.companyID).subscribe(
      (data) => {
        if (data.status) {
          this.jorneyType = data?.rows;
          this.jorneyType = this.jorneyType.sort((a, b) => {
            return a.journey_name.localeCompare(b.journey_name);
          });
          this.ngxSpinnerService.hide();
        } else {
          this.jorneyType = [];
          this.ngxSpinnerService.hide();
        }
      },
      (error) => {
        console.log(error);
        this.ngxSpinnerService.hide();
      },
    );
  }

  getThemeList() {
    if (!this.journeyID) return;
    this.ngxSpinnerService.show();
    this.clientService
      .getAllThemeWithJourney(this.companyID, this.journeyID, this.domainID)
      .subscribe(
        (data) => {
          if (data.status) {
            this.themeList = data?.rows;
            this.themeList = this.themeList.sort((a, b) => {
              return a.theme_name.localeCompare(b.theme_name);
            });
            this.ngxSpinnerService.hide();
          } else {
            this.themeList = [];
            this.ngxSpinnerService.hide();
          }
        },
        (error) => {
          console.log(error);
          this.ngxSpinnerService.hide();
        },
      );
  }

  getBusinessDomain() {
    let self = this;
    this.master.getBusinessDomain(100, 0, this.companyID).subscribe(
      (data) => {
        // ensure ids are numbers, material selects compare using ===
        self.domainData = data.data.rows.map((d: any) => ({
          ...d,
          id: Number(d.id),
        }));
        // reapply previously stored value, converting if necessary
        if (this.prevDomainID !== null && this.prevDomainID !== undefined) {
          this.domainID = Number(this.prevDomainID);
        }
        // if the selected domain doesn’t exist for the current company,
        // clear it (prevents showing a value with no matching option)
        if (
          this.domainID !== null &&
          !self.domainData.some((d: any) => d.id === this.domainID)
        ) {
          this.domainID = null;
          // reflect in shared state as well
          this.tableState.updateFilters({ domainID: null });
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  onCompanyChange(event: MatSelectChange) {
    const value = event.value as number;

    // ignore programmatic assignments during initialization – they
    // shouldn't clear the existing domain filter (see handleInitialLoad).
    if (value === this.tableState.snapshot.filters.companyID) {
      // still update domain list in case it changed externally
      if (value) {
        this.getBusinessDomain();
      }
      return;
    }

    this.themeList = []; // Reset Theme List
    if (value) {
      this.getBusinessDomain();
    }
    this.tableState.updateFilters({
      companyID: value,
      journeyID: null,
      themesID: [],
      domainID: null,
    });
  }

  refreshTemplateList() {
    this.getEmailTemplateData(this.companyID);
  }
  onJourneyChange(event: MatSelectChange) {
    const value = event.value as number;
    if (!this.journeyID) {
      this.themeList = [];
    }
    this.tableState.updateFilters({ journeyID: value, themesID: [] });
  }
  onDomainChange(event: MatSelectChange) {
    const value = event.value as number;
    this.tableState.updateFilters({ domainID: value });
  }

  onThemeChange(event: MatSelectChange) {
    const value = event.value as number[];
    this.tableState.updateFilters({ themesID: value });
  }

  //Fetch Email Templates Data
  getEmailTemplateData(cid: any, source?: string) {
    let self = this;
    this.skip = (this.page - 1) * this.limit;
    const journey_id = this.journeyID;
    const theme_id = this.themesID;
    this.ngxSpinnerService.show();
    const domain_id = this.domainID;
    this.eb
      .getEmailTemplatesList(
        cid,
        domain_id,
        journey_id,
        theme_id,
        this.searchTemplateText,
        this.limit,
        this.skip,
      )
      .subscribe(
        (data) => {
          if (data.status && data.data.rows.length > 0) {
            self.companyObj = data.data.rows;
            self.templateFilterData = [...this.companyObj];
            self.totalCount = data.data.total;
          } else {
            self.companyObj = [];
            self.templateFilterData = [];
            self.totalCount = 0;
          }
          this.ngxSpinnerService.hide();
        },
        (error) => {
          this.ngxSpinnerService.hide();
        },
      );
  }

  //Edit Email Template
  editEmailTemplate(id) {
    this.router.navigate(["/corporate/cb-email-builder"], {
      queryParams: { id: id, cid: this.companyID },
    });
  }

  //Delete Emlail Template
  deleteEmailTemplate(id) {
    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        CommonMessages.deleteConfirmation,
        "Yes",
        "No",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.eb.deleteEmailTemplate(this.companyID, id).subscribe(
            (data) => {
              if (data.status) {
                this.getEmailTemplateData(this.companyID);
                setTimeout(() => {
                  this.toastrService.success("Template Deleted Successfully.");
                }, 1000);
              } else {
                this.toastrService.error(data.message);
              }
              this.ngxSpinnerService.hide();
            },
            (error) => {
              // console.log(error);
              this.ngxSpinnerService.hide();
            },
          );
        }
      })
      .catch(() => console.log(CommonMessages.dialogDismissMessage));
  }

  cloneEmailTemplate(item: any) {
    
    this.currentCloneData = {
      template_id: Number(item.id),
      template_name: item.template_name + ' Copy',
      template_subject: item.template_subject,
      company_id: Number(item.company_id),
      domain_id: Number(item.business_domain_id),
      journey_id: Number(item.journey_id),
      theme_id: item.theme_ids
        ? item.theme_ids.split(',').map(Number)
        : (item.theme_id ? [Number(item.theme_id)] : []),
    };
    this.isCloneModalOpen = true;
  }

  closeCloneModal() {
    this.isCloneModalOpen = false;
    this.currentCloneData = null;
  }

  // Update Template Status
  updateTemplateStatus(template: any) {
    console.log("Template to update:", template);

    const newStatus: boolean = template.isactive;
    const cid = template.company_id;
    const tid = template.id;

    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        !newStatus
          ? CommonMessages.activeTemplateConfirmation
          : CommonMessages.inactiveTemplateConfirmation,
        "Yes",
        "No",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.campaignBuilderService
            .updateTemplateStatus(cid, tid, !newStatus)
            .subscribe(
              (data) => {
                this.ngxSpinnerService.hide();
                template.isactive = !template.isactive;
              },
              (error) => {
                console.log("updateJourneyStatus error:", error);
                this.ngxSpinnerService.hide();
              },
            );
        }
      })
      .catch(() => {
        console.log(CommonMessages.dialogDismissMessage);
        //  journey.isactive = !journey.isactive;
      });
  }

  setValue(event: any, item: any) {
    let self = this;
    let urls = event.target.src.split(",").map((s: any) => s.trim());
    let url = urls.length >= 0 ? urls[0] : event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length);
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        // self.image_awskey = url;
        event.target.src = self.isUrlValid(awsUrl)
          ? awsUrl
          : "../../../assets/custom/images/profile.png";
        item.theme_screenshot = event.target.src;
      } else {
        event.target.src = "../../../assets/custom/images/profile.png";
        item.theme_screenshot = event.target.src;
      }
    } else {
      event.target.src = "../../../assets/custom/images/profile.png";
      item.theme_screenshot = event.target.src;
    }
    event.target.onerror = null;
  }
  isUrlValid(userInput: any) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(
      userInput,
    );
  }
  ValidateUrl(control: AbstractControl) {
    return /(https|http):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(
      control.value,
    )
      ? null
      : { validUrl: true };
  }

  onPageChange() {
    this.tableState.updatePagination(this.page, this.limit);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
